import { Action, createReducer, on } from '@ngrx/store';
import * as fromActions from './newsletter-preview.actions';

export enum CampaignSubscribeStatus {
	NotSubscribed= 0,
	Subscribed = 1,
	Unsubscribed = 2,
}

export interface State {
	isSubscribed: CampaignSubscribeStatus;
}

export const initialState: State = {
	isSubscribed: null
};

export const newsletterPreviewReducer = createReducer(
	initialState,
	on(fromActions.subscription.isSubscribedSuccess, (state, {isSubscribed}) => ({
		...state,
		isSubscribed
	})),
	on(fromActions.subscription.subscribeSuccess, (state) => ({
		...state,
		isSubscribed: 1,
	})),
	on(fromActions.subscription.unsubscribeSuccess, (state) => ({
		...state,
		isSubscribed: 2,
	})),
	on(fromActions.clear, (state) => ({
		...initialState,
	})),
);

export function reducer(state: State | undefined, action: Action) {
	return newsletterPreviewReducer(state, action);
}

export const getIsSubscribed = (state: State) => state.isSubscribed;
